import $http from '@/core/services/http.service';
import { ActionTree } from 'vuex';

import TokenService from '@/core/services/token.service';
import { State } from '@/core/store/auth/state';
import Endpoints from '@/constants/endpoints';

export interface Actions {
    authRequest: {
        email: string,
        password: string,
    };
    authLogout: {};
    fetchProfile: {};
}

export const actions: ActionTree<State, any> = {
    authRequest: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit('authRequest', payload);
            $http.post(`${Endpoints.login}`, payload)
                .then((res) => {
                    const token = res.data.key;
                    TokenService.set(token);
                    commit('authSuccess', { token });
                    resolve(res);
                }).catch((err) => {
                    commit('authError', payload);
                    TokenService.clear();
                    reject('PARECE QUE LOS DATOS SON INCORRECTOS');
                });
        });
    },
    authLogout: ({ commit }) => {
        return new Promise((resolve) => {
            commit('authLogout', {});
            TokenService.clear();
            resolve();
        });
    },
    fetchProfile: ({ commit }) => {
        return new Promise((resolve, reject) => {
            $http.get(`${Endpoints.profile}`)
                .then((res) => {
                    const data = res.data;
                    commit('setProfile', data);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    fetchuserPermissions: ({ commit }) => {
        return $http.get(`${Endpoints.user_permissions}`)
            .then((res) => {
                const data = res.data;
                commit('setUserPermissions', data);
                return data; 
            })
            .catch((err) => {
                console.error(err); 
                throw err;
            });
    },

};
